export function findNextFragmentTime(
  fragmentTimes: readonly number[],
  currentTime: number,
): number | undefined {
  // Binary search to find the first fragment strictly greater than currentTime
  let low = 0;
  let high = fragmentTimes.length - 1;

  while (low <= high) {
    const mid = Math.floor((low + high) / 2);
    const midTime = fragmentTimes[mid];
    if (midTime === undefined) {
      break;
    }
    if (currentTime < midTime) {
      high = mid - 1;
    } else {
      low = mid + 1;
    }
  }

  return low < fragmentTimes.length ? fragmentTimes[low] : undefined;
}
